import { Injectable } from '@angular/core';

import { ColumnHandlerService } from '../../record/services/column-handler.service';
import {
    DownloadCreationDateCellComponent,
    DownloadExpiryDateCellComponent
} from '../components/cells/download-date-cell/download-date-cell.component';
import { DownloadActionCellComponent } from '../components/cells/download-action-cell/download-action-cell.component';
import { DownloadFoutenCellComponent } from '../components/cells/download-fouten-cell/download-fouten-cell.component';
import { DownloadNaamCellComponent } from '../components/cells/download-naam-cell/download-naam-cell.component';
import { DownloadStatusCellComponent } from '../components/cells/download-status-cell/download-status-cell.component';
import { DownloadRow } from '../entities/download-row.entity';

export enum DownloadColumn {
    Naam = 'naam',
    Status = 'status',
    Downloaddatum = 'downloaddatum',
    Vervaldatum = 'vervaldatum',
    Fouten = 'fouten',
    Actie = 'actie'
}

@Injectable()
export class DownloadsColumnHandlerService extends ColumnHandlerService<DownloadRow> {
    constructor() {
        super();

        this.components.set(DownloadColumn.Naam, DownloadNaamCellComponent);
        this.components.set(DownloadColumn.Status, DownloadStatusCellComponent);
        this.components.set(DownloadColumn.Downloaddatum, DownloadCreationDateCellComponent);
        this.components.set(DownloadColumn.Vervaldatum, DownloadExpiryDateCellComponent);
        this.components.set(DownloadColumn.Fouten, DownloadFoutenCellComponent);
        this.components.set(DownloadColumn.Actie, DownloadActionCellComponent);
    }
}
